import React,{useState,useEffect} from 'react';
import {Helmet} from "react-helmet";
import { SpinerLoad } from '../comps/comps'
import {useSelector,useDispatch} from 'react-redux'
import * as authAction from '../store/authAction'
import * as dataAction from '../data/payment_data'
import {useNavigate} from 'react-router-dom';
import { FiEye, FiHeart, FiCreditCard, FiArrowUpRight } from 'react-icons/fi'
import { IoIosArrowBack } from 'react-icons/io'
import '../styles/earnings.css'

const Earnings = props => {
    const dispatch = useDispatch();
     const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(()=>{
    const loadEarnings = async () => {
      const userData = localStorage.getItem('userdata');
      try {
        if(userData){
          const {id,pid} = JSON.parse(userData);
          await dispatch(authAction.auth(id,pid));
          await dispatch(dataAction.get_cashout());
        }else{
          navigate('auth');
        }
      } finally {
        setIsLoading(false);
      }
    }
    loadEarnings();
  },[dispatch, navigate])

 const moneyDet = useSelector(state => state.sub_reduse) || {};
 const views = Number(moneyDet.totalViews) || 0;
 const likes = Number(moneyDet.pCount) || 0;
 const balance = ((views + likes / 10) / 98).toFixed(2);

  return(
  <section className='Earnings'>
    <Helmet>
    <title>Pinweelo cash out</title>
    <meta name="theme-color" content="#08090d" />
    <meta name="description" content='here you can find our goals and what we are trying to make  '/>
    <meta name='keywords' content='about us,info about,envera website,aboutus page,enveraworld page,enveraworld about us'/>
     <link rel="canonical" href="https://pinweelo.com/about-us" />
    </Helmet>

<header className="earnTop">
  <button type="button" className="earnBack" onClick={() => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/profile');
  }} aria-label="Go back"><IoIosArrowBack /></button>
  <h1>Earnings</h1>
</header>

{isLoading ? <div className="earnLoad"><SpinerLoad compact /></div> : <>
<div className="earnShell">
  <header className="earnHero">
    <p className="earnKicker">Creator</p>
    <p className="earnLead">Balance, activity, and payouts in one place.</p>
  </header>

  <div className="criditViewMian">
    <article className="criditView">
      <p>Name like in the Bank Credit Card</p>
      <div className="earnCardMeta"><span>**/**</span><span>***</span></div>
      <p>**** **** **** ****</p>
    </article>
    <article className="criditView">
      <p>Name like in the Bank Credit Card</p>
      <div className="earnCardMeta"><span>**/**</span><span>***</span></div>
      <p>**** **** **** ****</p>
    </article>
    <article className="criditView">
      <p>Name like in the Bank Credit Card</p>
      <div className="earnCardMeta"><span>**/**</span><span>***</span></div>
      <p>**** **** **** ****</p>
    </article>
  </div>

  <div className="earnBalance">
    <p>Available balance</p>
    <h2>${balance}</h2>
  </div>

  <div className="earnStats">
    <div className="earnDetials"><span><FiEye /></span><p>{views}</p><p>Total views</p></div>
    <div className="earnDetials"><span><FiEye /></span><p>{views}</p><p>Unpaid views</p></div>
    <div className="earnDetials"><span><FiHeart /></span><p>{likes}</p><p>Total likes</p></div>
    <div className="earnDetials"><span><FiCreditCard /></span><p>$00</p><p>Total withdraws</p></div>
  </div>

  <div className='cashbutton'>
    <button type="button" disabled><FiArrowUpRight /> Cash out</button>
  </div>
  <p className='errorcashout'>The minimum withdraw is $1000</p>
</div>
</>}

  </section>
  )
}
export default Earnings;
